import { MetricsOverview } from '@/features/admin/metrics/components/MetricsOverview';

export function AdminDashboardPage() {
  return (
    <div className="h-full bg-background overflow-auto lg:overflow-hidden">
      <div className="p-6 lg:h-full lg:flex lg:flex-col lg:min-h-0">
        <MetricsOverview />
      </div>
    </div>
  );
}
